import { selectSelectedTransaction } from '../../../../../store/workspace/selectors';
import { setTransactionDetailModal } from '../../../../../store/workspace/slice';
import { useDispatch, useSelector } from '../../../../../store/store';
import styles from './style.module.scss';
import Modal from '../../../../../components/Modal';
import { ReactNode } from 'react';
import {
    CheckSolidIcon,
    TimesSolidIcon,
    BillingDetailIcon,
    NotApplicableIcon,
} from '../../../../../assets/icons';

/** Headline of the modal, per invoice status the payment API reports. */
const statusHeadlines: Record<string, { icon: ReactNode; text: string }> = {
    paid: { icon: <CheckSolidIcon />, text: 'Paid Successfully' },
    unpaid: { icon: <TimesSolidIcon />, text: 'Paid Unsuccessful' },
    refund: { icon: <NotApplicableIcon />, text: 'Paid Refunded' },
};

/** Read-only breakdown of a single invoice, with a link to its Stripe receipt. */
export default function TransactionDetail() {
    const dispatch = useDispatch();
    const transaction = useSelector(selectSelectedTransaction);
    const headline = transaction ? statusHeadlines[transaction.status] : undefined;

    const closeModal = () => dispatch(setTransactionDetailModal(false));

    const downloadReceipt = () => {
        if (!transaction?.receipt_url) return;
        window.open(transaction.receipt_url, '_blank');
    };

    return (
        <Modal
            size='sm'
            actions='both'
            title='Billing details'
            closeFunc={closeModal}
            icon={<BillingDetailIcon />}
            childClassName={styles.wrapper}
            dismissButton={{
                text: 'Close',
                type: 'Outline-Dark',
                onClick: closeModal,
            }}
            confirmButton={{
                text: `Download ${transaction?.status === 'unpaid' ? 'Invoice' : 'Receipt'}`,
                type: 'Primary',
                onClick: downloadReceipt,
            }}
        >
            <div className={styles.status} data-status={transaction?.status}>
                {headline && <>
                    {headline.icon}
                    <span>{headline.text}</span>
                </>}
            </div>
            <div className={styles.row}>
                <span className={styles.row_prop}>Invoice number</span>
                <span className={styles.row_val}>{transaction?.invoice_id}</span>
            </div>
            <div className={styles.row}>
                <span className={styles.row_prop}>Status</span>
                <span className={styles.row_val}>{transaction?.status}</span>
            </div>
            <div className={styles.row}>
                <span className={styles.row_prop}>Amount</span>
                <span className={styles.row_val}>
                    {transaction?.amount_paid ? `${transaction.amount_paid / 100}$` : '----'}
                </span>
            </div>
            <div className={styles.row}>
                <span className={styles.row_prop}>Date</span>
                <span className={styles.row_val}>
                    {transaction ? new Date(transaction.created * 1000).toDateString() : '----'}
                </span>
            </div>
        </Modal>
    );
};
